// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__gJ4KH","options":"AnswerScale_options__3Z7p5","selected":"AnswerScale_selected__4w4S1"};